import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { AppMessageSeverity } from "../../models/enums/AppMessageSeverity.enum";
import { OAuthIntegration } from "../../models/oauth-integration";

@Component({
	selector: "app-quickbooks-oauth-connect",
	templateUrl: "./quickbooks-oauth-connect.component.html",
	styleUrls: ["./quickbooks-oauth-connect.component.scss"],
})
export class QuickbooksOauthConnectComponent implements OnInit {
	@Input() dealerKey: string;
	@Output() dealerKeyChange = new EventEmitter<string>();

	@Input() function: string;
	@Output() functionChange = new EventEmitter<string>();

	@Input() refreshedToken: OAuthIntegration;
	@Output() refreshedTokenChange = new EventEmitter<OAuthIntegration>();

	@Input() source: string;
	@Output() sourceChange = new EventEmitter<string>();

	@Input() venueKey: number;
	@Output() venueKeyChange = new EventEmitter<number>();

	quickbooksAuthorizationUrl: string;

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}

	async quickbooksRefresh() {
		try {
			const resp = await this.focuslink.quickbooksOauthRefresh(this.dealerKey || this.venueKey);
			this.refreshedTokenChange.emit(new OAuthIntegration(resp));
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `message` });
		}
	}

	async quickbooksConnect() {
		try {
			const isLocalhost = window.location.hostname === "localhost" ? true : false;
			const resp = await this.focuslink.quickbooksOauthUrlGet(this.source, this.venueKey, this.dealerKey, isLocalhost);

			window.open(resp.authUri, "_blank");
			this.function = "disconnect";
			setInterval(async () => {
				const resp = await this.focuslink.oAuthTokenGet(`quickbooks`, this.venueKey, this.dealerKey);
				if (resp) {
					this.refreshedTokenChange.emit(new OAuthIntegration(resp));
					clearInterval();
				}
			}, 30000);
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Sorry, there was an error connecting to QuickBooks` });
		}
	}

	async quickbooksDisconnect() {
		try {
			await this.focuslink.quickbooksOauthDelete(this.venueKey || this.dealerKey);
			this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `QuickBooks disconnected` });
			this.function = "connect";
			this.refreshedTokenChange.emit(undefined);
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Error disconnecting.` });
		}
	}
}
